<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="真伪查询"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>
    <div class="container-item">
      <van-card shadow="never" class="search-card">
        <template #desc>
          <van-field
              readonly
              clickable
              name="picker"
              :value="number"
              label="球杆序列号"
              placeholder="点击选择序列号"
              @click="showPicker = true"
              class="search-input"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-picker
                show-toolbar
                :columns="selectOptions"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
          </van-popup>
        </template>
      </van-card>

      <van-button v-if="number" class="search-btn" block @click="search">查询</van-button>
    </div>
    <!-- 补充自定义弹窗的DOM结构 -->
    <van-dialog
        v-model="showDialog"
        title="查询结果"
        :dangerously-use-html-string="true"
        :message="messageContent"
    />
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {checkPortal, productByUser} from "@/api/sales";
import {Dialog} from "vant";

export default {
  data(){
    return {
      number: '',
      selectOptions: [],
      showPicker: false,
      // 补充缺失的data属性
      showDialog: false,
      messageContent: ''
    }
  },
  created() {
    this.selectProductByUser();
  },
  methods: {
    //顶部标题栏返回事件
    onClickLeft() {
      this.$router.push('/app_home');
    },
    //序列号确认事件
    onConfirm(value) {
      this.number = value;
      this.showPicker = false;
    },

    showDialogMsg(message){
      Dialog.alert({
        title: '查询结果',
        message: message,
        dangerouslyUseHTMLString: true
      });
    },
    //获取当前登录人名下注册登记的球杆
    selectProductByUser(){
      productByUser().then(res => {
        if (res.code === 200) {
          if(res.data){
            this.selectOptions = res.data.map(item => item.value);
          }
        } else {
          Dialog.alert({
            title: '提示',
            message: res.returnMsg,
            dangerouslyUseHTMLString: true
          }).then(() => {
            // on close
          });
        }
      }).catch(err => {
        Dialog.alert({
          title: '错误',
          message: '获取序列号失败，请稍后重试',
          dangerouslyUseHTMLString: true
        });
      })
    },
    // 真伪查询
    search(){
      if(!this.number){ // 优化判空逻辑
        this.showDialogMsg('请输入球杆编号');
        return;
      }
      //球杆编号
      const keyWord = this.number;
      //查询真伪接口
      checkPortal(keyWord).then(res => {
        if(res.code === 200){
          const data = res.data;
          const code = data.code;
          let msgStr = "";

          if(code === 5){
            msgStr = `<p class="no-margin">此杆号已失效，假货和克隆号可能性极大，请联系官方售后电话或找附近经销商确认.</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.showDialogMsg(msgStr);
          } else if(code === 0) {
            this.showDialogMsg(data.returnMsg);
          } else if(code === 2) {
            msgStr = `<p>很遗憾，您所查询的杆号非璟点公司提供正品行货，没有售后保障。请联系官方售后电话或找附近经销商确认。</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>
                            `;
            this.showDialogMsg(msgStr);
          } else if(code === 1) {
            if(data.check_number > 5) {
              msgStr = `<p>此杆号已失效，假货和克隆号可能性极大，请联系官方售后电话或找附近经销商确认</p>
                                <p>球杆售后咨询：<a href="tel:18603360681">18603360681</a></p>`;
              this.showDialogMsg(msgStr);
            } else {
              let agent_name = "";
              if(data.agent_name && data.agent_name !== ''){
                agent_name = "，授权销售商为”"+data.agent_name+"“。";
              }
              msgStr = `
                                    <p>恭喜您！该编号[${data.portal_number}]商品为正品，请您放心使用。</p>
                                    <p>${data.portalspecs?'该编号商品为['+data.portalspecs+']':''}</p>
                                    <p>该编号商品出货日期为[${data.create_time}]${agent_name}
                                    <p>该编号商品已查询[${data.check_number}]次</p>
                                    <p>上次查询时间[${data.cx_time}]</p>
                                `;
              this.showDialogMsg(msgStr);
            }
          }
        } else {
          // 处理接口返回非200的情况
          Dialog.alert({
            title: '提示',
            message: res.returnMsg || '查询失败，请稍后重试',
            dangerouslyUseHTMLString: true
          });
        }
      }).catch(err => {
        // 补充接口异常捕获
        Dialog.alert({
          title: '错误',
          message: '查询失败，请检查网络或稍后重试',
          dangerouslyUseHTMLString: true
        });
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .van-icon-arrow-left {
  color: #0f0f0f !important;
}
::v-deep .van-nav-bar__text {
  color: #0f0f0f !important;
}
.top-bar{
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}
.container-item {
  padding: 0 16px;
}
.search-card {
  margin: 16px 0;
  border-radius: 12px;
  height: 200px;
  /* 新增背景图样式 */
  background-image: url('~@/assets/img/h5/search_bj.png');
  background-size: cover; /* 背景图覆盖整个容器 */
  background-repeat: no-repeat; /* 不重复显示 */
  background-position: center center; /* 背景图居中显示 */
}
.search-input{
  margin-top: 160px;
  border-radius: 10px;
  border-bottom: none;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
}

.search-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  color: #000;
  font-size: 16px;
  font-weight: bold;
  border: none;
  margin-bottom: 16px;
  margin-top: 32px;
}
.no-margin {
  margin: 0;
}
</style>